export default "__VITE_ASSET__Dp4C6Lp9__"